import "./App.css";
import "bootstrap/dist/css/bootstrap.css";
import { BrowserRouter } from "react-router-dom";
import MyRoutes from "./components/routes/MyRoutes";
import { SidebarProvider } from "./components/SidebarContext";

function App() {
  return (
    <>
      <BrowserRouter>
        <SidebarProvider>
          <MyRoutes />
        </SidebarProvider>
      </BrowserRouter>
    </>
  );
}
export default App;
